/**
 * `start_param` кнопки бота «Поддержка ответила на обращение TK-…» (BE-57):
 * `t_<ticketId>` — id обращения, тот же, что в `GET /app/tickets/{id}`.
 * Возвращает id как есть: негодный и чужой показывает экран обращения —
 * «Обращение не найдено», а не витрина. Не наша ссылка — `null`.
 */
export const parseTicketStartParam = (startParam: string | null): string | null =>
  startParam?.startsWith('t_') && startParam.length > 2 ? startParam.slice(2) : null
